<template>
  <div>
    <div
      style="
        border-bottom: 1px solid rgba(155, 155, 155, 0.25);
        margin-bottom: 20px;
      "
    >
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="报表名称">
          <el-select v-model="formInline.code" clearable placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSubmit"
            class="bg5584FF formBotton"
            >查询</el-button
          >
          <el-button type="info" @click="reset" class="formBotton"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-table
      border
      :data="tableData"
      stripe
      style="width: 100%"
      :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
      v-loading="loading"
    >
      <el-table-column type="index" width="50" fixed></el-table-column>
      <el-table-column prop="name" label="报表名称" fixed>
        <template slot-scope="scope">
          <span class="detail" @click="handleDetail(scope.row)">{{
            scope.row.name
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="report_cycle" label="填报周期" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.report_cycle == 0">月报</span>
          <span v-else-if="scope.row.report_cycle == 1">季报</span>
          <span v-else-if="scope.row.report_cycle == 2">半年报</span>
          <span v-else>年报</span>
        </template>
      </el-table-column>
      <el-table-column prop="date_range" label="填报期" align="center">
        <template slot-scope="scope">
          <span>{{ getDateRange(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="date_range_end"
        label="填表截止日"
        align="center"
      ></el-table-column>
      <el-table-column prop="crt_time" label="填表日期" align="center">
        <template slot-scope="scope">
          <span>
            {{ $moment(scope.row.crt_time).format("YYYY-MM-DD HH:mm:ss") }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="220">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.sqxg_status != '0'"
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="rea(scope.row)"
            >查看原因</el-button
          >
          <el-button
            v-if="scope.row.sqxg_status !== '1'"
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="edit(scope.row)"
            >申请修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox">
      <el-pagination
        class="pagePC"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="20"
        layout="total,  prev, pager, next"
        :total="total"
      >
      </el-pagination>
      <van-pagination
        class="pagePhone"
        v-model="currentPage"
        :total-items="total"
        :items-per-page="20"
        :show-page-size="3"
        @change="changePage"
        force-ellipses
      />
    </div>
    <el-dialog
      v-if="editDialogVisible"
      title="申请报表修改"
      :visible.sync="editDialogVisible"
      class="dialog770 titleChange"
      style="min-height: 300px"
      :width="screenWidth < 1200 ? '94%' : '1100px'"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <el-form label-width="80px" label-position="top">
        <el-form-item label="申请原因">
          <el-input type="textarea" v-model="apply_reason"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="apply" :loading="loading"
          >申请</el-button
        >
        <el-button @click="clos" :loading="loading">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-if="reasonDialogVisible"
      title="查看原因"
      :visible.sync="reasonDialogVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :width="screenWidth < 1200 ? '94%' : '40%'"
    >
      <el-form label-width="120px">
        <el-form-item label="申请状态：">
          <el-select
            v-model="reason.sqxg_status"
            disabled
            placeholder="请选择活动区域"
          >
            <el-option label="未申请" value="0"></el-option>
            <el-option label="申请修改" value="1"></el-option>
            <el-option label="申请修改通过" value="2"></el-option>
            <el-option label="申请修改不通过" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请原因：">{{
          reason.apply_reason
        }}</el-form-item>
        <el-form-item label="报表审核意见：">{{
          reason.handle_reason
        }}</el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      v-if="showDialogVisible"
      title="查看"
      :visible.sync="showDialogVisible"
      class="dialog770 titleChange"
      :width="screenWidth < 1200 ? '94%' : '1160px'"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <zdquczbShow
        v-if="editCode == '001'"
        :id="editId"
        :report_yidong="report_yidong"
      ></zdquczbShow>
      <zdjcqycwbShow
        v-if="editCode == '002'"
        :id="editId"
        :report_yidong="report_yidong"
      ></zdjcqycwbShow>
      <gyyqjbqkbShow
        v-if="editCode == '003'"
        :id="editId"
        :report_yidong="report_yidong"
      ></gyyqjbqkbShow>
    </el-dialog>
  </div>
</template>

<script>
import zdquczbShow from "../notInsert/zdquczbShow/index";
import zdjcqycwbShow from "../notInsert/zdjcqycwbShow/index";
import gyyqjbqkbShow from "../notInsert/gyyqjbqkbShow/index";

export default {
  name: "index",
  components: {
    zdquczbShow,
    zdjcqycwbShow,
    gyyqjbqkbShow,
  },
  data() {
    return {
      screenWidth: document.body.clientWidth, // 屏幕宽
      screeHeight: document.body.clientHeight, // 屏幕高
      options: [],
      pageSize: 20,
      showDialogVisible: false,
      tableData: [],
      pageNum: 1,
      total: 0, //表格总数
      loading: false,
      currentPage: 1,
      formInline: {
        //查询对象
        code: "",
      },
      editDialogVisible: false,
      editCode: "001",
      editId: "",
      apply_reason: "",
      reasonDialogVisible: false,
      reason: {},
      report_yidong: 1,
    };
  },
  methods: {
    getDateRange(row) {
      const month = Number(row.date_range.split("-")[1]);
      const year = Number(row.date_range.split("-")[0]);
      if (row.report_cycle == 0) {
        //月报
        return row.date_range;
      } else if (row.report_cycle == 1) {
        //季报
        if (month <= 3) {
          return `${year}年第一季度`;
        } else if (month >= 4 && month <= 6) {
          return `${year}年第二季度`;
        } else if (month >= 7 && month <= 9) {
          return `${year}年第三季度`;
        } else {
          return `${year}年第四季度`;
        }
      } else if (row.report_cycle == 2) {
        //半年报
        if (month <= 6) {
          return `${year}年上半年`;
        } else {
          return `${year}年下半年`;
        }
      } else {
        //年报
        return `${year}年`;
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getdata(1);
    },
    clos() {
      this.editDialogVisible = false;
      this.getdata(1);
    },
    getdata(pageNum) {
      this.loading = true;
      this.$axios
        .get("/business/data-insert/insert/page", {
          params: {
            pageNum: pageNum,
            pageSize: this.pageSize,
            code: this.formInline.code,
          },
        })
        .then((res) => {
          this.loading = false;
          this.tableData = res.data;
          this.total = res.total;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    initSelect() {
      this.loading = true;
      this.$axios
        .get("/business/data-insert/report-select")
        .then((res) => {
          this.loading = false;
          this.options = res.data;
          console.log(res);
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    edit(row) {
      this.editCode = row.code;
      this.editId = row.id;
      this.apply_reason = "";
      this.report_yidong = row.report_yidong;
      this.editDialogVisible = true;
      console.log(row);
    },
    rea(row) {
      this.reason = row;
      this.reasonDialogVisible = true;
      console.log(row);
    },
    handleDetail(row) {
      this.editId = row.id;
      this.editCode = row.code;
      this.report_yidong = row.report_yidong;
      this.showDialogVisible = true;
    },
    changePage() {
      this.pageNum = this.currentPage;
      this.getdata(this.currentPage);
    },
    handleCurrentChange(val) {
      //跳转页
      this.getdata(val);
    },
    onSubmit() {
      this.getdata(1);
    },
    reset() {
      this.formInline = {
        code: "",
      };
      this.getdata(1);
    },
    apply() {
      const self = this;
      self.loading = true;
      const data = {
        id: self.editId,
        apply_reason: self.apply_reason,
      };
      self.$axios
        .post("/business/data-insert/apply-edit", data)
        .then((res) => {
          self.loading = false;
          self.clos();
        })
        .catch((err) => {
          self.loading = false;
          console.log("error", err);
        });
    },
  },
  created() {
    this.getdata(1);
    this.initSelect();
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
  },
};
</script>

<style scoped>
.detail {
  width: 100%;
  height: 100%;
  cursor: pointer;
  color: #5584ff;
}
.pagePhone {
  display: none;
}

@media (max-width: 1200px) {
  .pagePC {
    display: none;
  }
  .pagePhone {
    display: flex;
  }
  .phone_btn_margin {
    margin-left: 0 !important;
    margin-top: 4px;
  }
}
</style>